"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormListItem = exports.StyledActionDialog = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("../../generic");
exports.StyledActionDialog = (0, styled_components_1.default)(generic_1.ActionDialog) `
  .MuiDialog-paper {
    min-height: 300px;
  }
`;
exports.StyledFormListItem = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  && .MuiInputBase-root.Mui-disabled {
    background-color: ${ui_components_1.baseColors.background100};

    .MuiOutlinedInput-notchedOutline {
      border-color: ${ui_components_1.baseColors.background200};
    }
  }

  .list-item-node-name {
    min-width: 350px;
  }

  && .text-field--small .MuiInputBase-root {
    min-height: 48px;
  }
`;
